import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common.ts'
import { z } from 'zod'

export const Sale1210SearchParamsSchema = z
  .object({
    sourceFileName: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)
export type Sale1210SearchParams = z.infer<typeof Sale1210SearchParamsSchema>

export const Sale1210SearchResultModelSchema = z.object({
  id: z.number(),
  sourceFileName: z.string(),
  createdAt: z.coerce.date(),
  status: z.number(),
})

export type Sale1210SearchResultModel = z.infer<
  typeof Sale1210SearchResultModelSchema
>

export const Sale1210SearchResultSchema = z
  .object({
    data: z.array(Sale1210SearchResultModelSchema),
  })
  .merge(BasePaginateResultSchema)

export type Sale1210SearchResult = z.infer<typeof Sale1210SearchResultSchema>
